import { formatThreadLabel } from './group-threads.js';
import { popOwner, pushLayer, updateLayer } from './context-nav-stack.js';

export const GROUP_CONTEXT_OWNER_ID = 'groups';
const LAYER_ID = 'group-shell';

export function teardownGroupContextNav() {
  popOwner(GROUP_CONTEXT_OWNER_ID);
}

/**
 * Build taco menu items for a group: Home, All groups, read-only group name, indented feeds.
 * @param {{ groupId: number, groupName: string, threads: { id: number, name: string }[] }} params
 */
export function buildGroupContextNavItems({ groupId, groupName, threads = [] }) {
  const base = `/groups/${groupId}`;
  const name = groupName || 'Group';
  return [
    { href: '/', label: '🏠 Home feed', dataRoute: '/' },
    { href: '/groups', label: '🌱 All groups', dataRoute: '/groups' },
    { kind: 'heading', label: name },
    { href: base, label: '📰 Main feed', dataRoute: base, indent: true },
    ...threads.map((t) => ({
      href: `${base}/threads/${t.id}`,
      label: formatThreadLabel(t.name),
      dataRoute: `${base}/threads/${t.id}`,
      indent: true
    }))
  ];
}

/**
 * @param {{ groupId: number, groupName: string, roleLabel?: string|null, threads: { id: number, name: string }[] }} params
 */
export function syncGroupContextNav({ groupId, groupName, roleLabel = null, threads = [] }) {
  pushLayer({
    ownerId: GROUP_CONTEXT_OWNER_ID,
    id: LAYER_ID,
    title: '',
    subtitle: roleLabel || null,
    items: buildGroupContextNavItems({ groupId, groupName, threads })
  });
}

export function updateGroupThreadsNav(groupId, groupName, roleLabel, threads) {
  updateLayer(GROUP_CONTEXT_OWNER_ID, LAYER_ID, {
    title: '',
    subtitle: roleLabel || null,
    items: buildGroupContextNavItems({ groupId, groupName, threads })
  });
}
